// src/components/ProsCons.tsx
import { CheckCircle, XCircle } from 'lucide-react';
import clsx from 'clsx';

interface Props {
  pros: string[];
  cons: string[];
  title?: string;
  className?: string;
  compact?: boolean; // For tighter layout in sidebars if needed
}

export function ProsCons({ pros, cons, title = 'Pros & Cons', className = '', compact = false }: Props) {
  return (
    <div className={clsx(
      "rounded-xl shadow-lg",
      compact ? "p-4 text-sm" : "p-6 sm:p-8",
      "bg-white/5 backdrop-blur-lg text-yellow-100",
      className
    )}>
      {title && (
        <h3 className={clsx("font-bold text-yellow-300", compact ? "text-lg mb-4" : "text-2xl mb-6")}>
          {title}
        </h3>
      )}

      <div className={clsx("grid gap-6", compact ? "grid-cols-1" : "md:grid-cols-2")}>
        {/* Pros */}
        <div>
          <h4 className={clsx("font-semibold text-green-400", compact ? "text-base mb-1" : "text-lg mb-2")}>✅ Pros</h4>
          <ul className="space-y-3">
            {pros.map((item, i) => (
              <li key={i} className="flex items-start gap-3">
                <CheckCircle className={clsx("mt-0.5", compact ? "w-4 h-4" : "w-5 h-5", "text-green-400")} />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Cons */}
        <div>
          <h4 className={clsx("font-semibold text-red-400", compact ? "text-base mb-1" : "text-lg mb-2")}>❌ Cons</h4>
          <ul className="space-y-3">
            {cons.map((item, i) => (
              <li key={i} className="flex items-start gap-3">
                <XCircle className={clsx("mt-0.5", compact ? "w-4 h-4" : "w-5 h-5", "text-red-400")} />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
